import script from "./CheckoutCvsResult.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckoutCvsResult.vue?vue&type=script&setup=true&lang=js"

import "./CheckoutCvsResult.vue?vue&type=style&index=0&id=bf974024&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf974024"]])

export default __exports__